// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"335":"statistic","378":"logs","472":"settings","966":"login"}[chunkId] + "." + {"335":"68a74cb0","378":"5689d53f","472":"74de7024","966":"e0aee596"}[chunkId] + ".css";
};